const OPACITY = "{OPACITY}";

export enum MissionColor {
  Green = "Green",
  Purple = "Purple",
  Orange = "Orange",
  Yellow = "Yellow",
  Blue = "Blue",
  Pink = "Pink",
}

export const getMissionColors = () => {
  return [
    {
      index: 0,
      color: MissionColor.Blue,
      value: `rgba(101, 181, 247, ${OPACITY})`,
    },
    {
      index: 1,
      color: MissionColor.Green,
      value: `rgba(66, 214, 115, ${OPACITY})`,
    },
    {
      index: 2,
      color: MissionColor.Purple,
      value: `rgba(173, 128, 214, ${OPACITY})`,
    },
    {
      index: 3,
      color: MissionColor.Orange,
      value: `rgba(250, 141, 44, ${OPACITY})`,
    },
    {
      index: 4,
      color: MissionColor.Yellow,
      value: `rgba(251, 206, 41, ${OPACITY})`,
    },
    {
      index: 5,
      color: MissionColor.Pink,
      value: `rgba(244, 113, 188, ${OPACITY})`,
    },
  ];
};

export const getColorFromString = (color: MissionColor | undefined, opacity: string) => {
  const colorString =
    getMissionColors().find((c) => c.color === color)?.value ??
    getMissionColors().find((c) => c.color === MissionColor.Blue)?.value!;
  return colorString.replace(OPACITY, opacity);
};

const hexToHsl = (hex: string) => {
  hex = hex.replace("#", "");

  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0,
    s = 0,
    l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;

    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }

    h /= 6;
  }

  return {
    h: h * 360,
    s: s * 100,
    l: l * 100,
  };
};

export const generateColor = (baseHex: string, index: number, total: number) => {
  // catch in case total is somehow less than 0
  if (!Number.isFinite(total) || total <= 0) {
    total = 1;
  }
  const { h, s, l } = hexToHsl(baseHex);

  // spread lightness across slices
  const lightness = Math.min(80, Math.max(35, l + (index - total / 2) * (30 / total)));

  // small saturation variation
  const saturation = Math.min(90, Math.max(50, s + (index % 2 === 0 ? 10 : -10)));

  return `hsl(${h}, ${saturation}%, ${lightness}%)`;
};;